import { render, staticRenderFns } from "./feats.vue?vue&type=template&id=181b936a&scoped=true&"
import script from "./feats.vue?vue&type=script&lang=js&"
export * from "./feats.vue?vue&type=script&lang=js&"
import style0 from "./feats.vue?vue&type=style&index=0&id=181b936a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181b936a",
  null
  
)

export default component.exports